import React from 'react';
import { t } from '../../../../modules/infra/i18n';

const ReturnItemMessage = () => (
  <p className="u-fontsize-huge">{t('common:refund_modal.item_returned_question')}</p>
);

export default ReturnItemMessage;
